import { createSelector } from '@ngrx/store';
import { virtualLocationsState } from '../root';

export const getVirtualLocations = createSelector(
    virtualLocationsState,
    (virtualLocations) => virtualLocations?.data
);
